import { render, staticRenderFns } from "./DocumentsRelation.vue?vue&type=template&id=7dc50dcc&scoped=true"
import script from "./DocumentsRelation.vue?vue&type=script&lang=js"
export * from "./DocumentsRelation.vue?vue&type=script&lang=js"
import style0 from "./DocumentsRelation.vue?vue&type=style&index=0&id=7dc50dcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc50dcc",
  null
  
)

export default component.exports